import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';

const HELP_DESK_ADMINS_QUERY_KEY = 'helpDeskAdmins';

export const getHelpDeskAdminsQueryKey = (accountId) => [HELP_DESK_ADMINS_QUERY_KEY, accountId];

/**
 * Normalize raw admin objects from the API so every admin has a computed `name`
 * and a consistent `image` field.  This ensures AssigneeDisplay renders the
 * same avatar regardless of whether the admin comes from the list endpoint
 * (denormalized assigneeName / assigneeAvatarUrl) or the admins endpoint.
 */
const normalizeAdmin = (raw) => {
  const firstName = raw.firstName || '';
  const lastName = raw.lastName || '';
  const name = raw.name || [firstName, lastName].filter(Boolean).join(' ') || '';
  return { ...raw, firstName, lastName, name, image: raw.image || raw.avatarUrl || null };
};

const useHelpDeskAdmins = ({ accountId, branchId, categoryId }) => {
  const queryKey = [...getHelpDeskAdminsQueryKey(accountId), branchId, categoryId];

  const { data } = useQuery(queryKey, () => api.fetchHelpDeskAdmins({ accountId, branchId, categoryId }), {
    enabled: !!accountId
  });

  const admins = useMemo(() => (data?.data ?? []).map(normalizeAdmin), [data]);

  return { admins };
};

export default useHelpDeskAdmins;
